import { render } from "./RecipeQA.vue?vue&type=template&id=52112410&scoped=true"
import script from "./RecipeQA.vue?vue&type=script&lang=js"
export * from "./RecipeQA.vue?vue&type=script&lang=js"

import "./RecipeQA.vue?vue&type=style&index=0&id=52112410&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52112410"]])

export default __exports__